import React, { useEffect, useState } from "react";
import { Card, Table, Tag, Skeleton } from "antd";
import { CalendarOutlined } from '@ant-design/icons';
import { fetchApi } from "../services/api";

export default function RecentScores() {
  const [scores, setScores] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadScores() {
      const res = await fetchApi("student/latest-top-ten-score-wp");
      setScores(res?.data || []);
      setLoading(false);
    }

    loadScores();
  }, []);

  const dataSource = React.useMemo(() => {
    let rank = 0;
    let prevScore = null;

    return [...scores]
      .sort((a, b) => b.marks_scored - a.marks_scored)
      .map((item, index) => {
        if (item.marks_scored !== prevScore) {
          rank += 1;
          prevScore = item.marks_scored;
        }

        return {
          ...item,
          key: index,
          rank,
        };
      });
  }, [scores]);

  const columns = [
    {
      title: "",
      dataIndex: "rank",
      width: 80,
      render: (rank) => (
        <div
          className="w-12 h-12 flex items-center justify-center rounded-md text-white text-lg font-bold shadow"
          style={{ backgroundColor: "#c9a0ff" }}
        >
          {rank}
        </div>
      ),
    },
    {
      title: "Student",
      dataIndex: "name",
      render: (text, row) => (
        <div className="flex flex-col leading-tight">
          <p className="font-semibold text-gray-800">
            {text.charAt(0).toUpperCase() + text.slice(1)}
          </p>
          <p className="text-gray-500 text-sm flex items-center gap-1">
            <CalendarOutlined />
            {new Date(row.date).toLocaleDateString()}
          </p>
        </div>
      ),
    },
    {
      title: "Score",
      dataIndex: "marks_scored",
      align: "right",
      render: (val) => (
        <Tag color="purple" className="text-base px-3 py-1">
          {val}/200
        </Tag>
      ),
    },
  ];

  if (loading) {
    return (
      <div className="bg-[#f3f3f3] min-h-screen py-14 px-4 flex justify-center">
        <Card className="w-full max-w-4xl">
          <Skeleton active paragraph={{ rows: 10 }} title={{ width: "50%" }} />
        </Card>
      </div>
    );
  }

  return (
    <div className="bg-[#f3f3f3] min-h-screen py-14 px-4">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-center text-3xl font-bold text-[#333]">
          Recent Top 10 Test Scores
        </h1>
        <p className="text-center text-gray-600 font-semibold tracking-wide mt-1">
          Last 3 Months
        </p>

        <Card className="mt-10 shadow-lg border border-gray-200">
          <div className="overflow-x-auto">
            <Table
              dataSource={dataSource}
              columns={columns}
              pagination={false}
              rowClassName="hover:bg-gray-50"
              className="custom-table"
            />
          </div>
        </Card>
      </div>
    </div>
  );
}
